import { EventEmitter, Input, Output } from '@angular/core';

import { ThfBreadcrumb, ThfDynamicFormField, ThfPageAction } from '@totvs/thf-ui';

import { browserLanguage, thfLocaleDefault } from '../../utils/util';

export const thfPageDynamicSearchLiteralsDefault = {
  en: {
    disclaimerGroupTitle: 'Displaying results filtered by:',
    filterSettingsPlaceholder: 'Search',
    quickSearchLabel: 'Quick search:'
  },
  es: {
    disclaimerGroupTitle: 'Presentando resultados filtrados por:',
    filterSettingsPlaceholder: 'Buscar',
    quickSearchLabel: 'BÃºsqueda rÃ¡pida:'
  },
  pt: {
    disclaimerGroupTitle: 'Apresentando resultados filtrados por:',
    filterSettingsPlaceholder: 'Pesquisar',
    quickSearchLabel: 'Pesquisa rÃ¡pida:'
  }
};

/**
 * @description
 *
 * Componente com as aÃ§Ãµes de pesquisa jÃ¡ definidas, bastando que o desenvolvedor implemente apenas a chamada para as APIs
 * e exiba as informaÃ§Ãµes.
 */
export class ThfPageDynamicSearchBaseComponent {

  private _filters: Array<ThfDynamicFormField> = [];

  literals = {
    ...thfPageDynamicSearchLiteralsDefault[thfLocaleDefault],
    ...thfPageDynamicSearchLiteralsDefault[browserLanguage()]
  };

  /** Nesta propriedade deve ser definido um array de objetos que implementam a interface `ThfPageAction`. */
  @Input('t-actions') actions?: Array<ThfPageAction> = [];

  /** Objeto com propriedades do breadcrumb. */
  @Input('t-breadcrumb') breadcrumb?: ThfBreadcrumb = { items: [] };

  /**
   * @optional
   *
   * @description
   *
   * Lista dos campos usados na busca avanÃ§ada. Caso o mesmo nÃ£o seja passado a busca avanÃ§ada nÃ£o serÃ¡ exibida.
   */
  @Input('t-filters') set filters(filters: Array<ThfDynamicFormField>) {
    this._filters = Array.isArray(filters) ? [...filters] : [];
  }

  get filters(): Array<ThfDynamicFormField> {
    return this._filters;
  }

  /** TÃ­tulo da pÃ¡gina. */
  @Input('t-title') title: string;

  /**
   * @description
   *
   * Evento disparado ao executar a pesquisa avanÃ§ada, o mesmo irÃ¡ repassar um objeto com os valores preenchidos no modal de pesquisa.
   *
   * > Campos nÃ£o preenchidos nÃ£o irÃ£o aparecer no objeto passado por parÃ¢metro.
   */
  @Output('t-advanced-search') advancedSearch?: EventEmitter<any> = new EventEmitter();

  /** Evento disparado ao remover um ou todos os disclaimers pelo usuÃ¡rio. */
  @Output('t-change-disclaimers') changeDisclaimers?: EventEmitter<any> = new EventEmitter();

  /** Evento disparado ao realizar uma busca pelo campo de pesquisa rÃ¡pida, o mesmo serÃ¡ chamado repassando o valor digitado. */
  @Output('t-quick-search') quickSearch?: EventEmitter<string> = new EventEmitter();

}
